import axiosClient from "./axios"

const uploadImage = async (formData: FormData, path: string): Promise<any> => {
  const response = await axiosClient.post(`/upload/image?path=${path}`, formData)

  return response.data
}

const deleteImage = async (publicId: string): Promise<any> => {
  const response = await axiosClient.delete(`/upload/image?publicId=${publicId}`)

  return response.data 
}

export { uploadImage, deleteImage }